import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en";
import sv from "./sv";

export const defaultNS = "translation";

export const resources = {
	en: { translation: en },
	sv: { translation: sv },
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: "en",
		defaultNS,
		keySeparator: ".",
		interpolation: { escapeValue: false },
		react: {
			transSupportBasicHtmlNodes: true,
			// transKeepBasicHtmlNodesFor: [""]
		},
	});

export default i18n;
